import { APP_ENVIRONMENT, EnvironmentService } from '@accesso/adk-portal-shared';
import { ButtonComponent, InputComponent } from '@accesso/ng-uds';
import { CommonModule } from '@angular/common';
import { AfterViewChecked, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChatService } from '../../core/services/chat.service';

@Component({
  selector: 'app-chatbox',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonComponent, InputComponent],
  templateUrl: './chatbox.component.html',
  styleUrls: ['./chatbox.component.scss'],
})
export class ChatboxComponent implements OnInit, AfterViewChecked {
  isChatOpen = false;
  currentMessage = '';
  messages: { id: number; text: string; isUser: boolean; loading?: boolean }[] = [];
  private messageId = 0;
  isWaiting = false;
  chatIcon = '';
  private chatHistory: { role: string; content: string }[] = [];

  @ViewChild('scrollMe') private messagesContainer: ElementRef;

  constructor(
    private chatService: ChatService,
    @Inject(APP_ENVIRONMENT) private environment: EnvironmentService
  ) {
    this.chatIcon = this.environment.getEnvironmentProperties().s3BucketBaseUrl + '/img/logo/accesso-sign.jpg';
  }

  ngOnInit() {
    this.addMessage('Hello! I am your AI assistant. How can I help you today?', false);
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  private scrollToBottom(): void {
    try {
      if (this.messagesContainer && this.messagesContainer.nativeElement) {
        this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight;
      }
    } catch (err) {
      console.error('Error scrolling to bottom:', err);
    }
  }

  toggleChat() {
    this.isChatOpen = !this.isChatOpen;
  }

  async sendMessage() {
    if (this.currentMessage.trim() && !this.isWaiting) {
      const userMessage = this.currentMessage;
      this.addMessage(userMessage, true);

      // Add loading message
      const loadingMsgId = ++this.messageId;
      this.messages.push({
        id: loadingMsgId,
        text: '',
        isUser: false,
        loading: true,
      });

      // Add to chat history
      this.chatHistory.push({ role: 'user', content: userMessage });

      this.currentMessage = '';
      this.isWaiting = true;

      try {
        this.chatService
          .sendMessage(this.chatHistory)
          .subscribe(
            (response) => {
              // Remove loading message
              this.messages = this.messages.filter((m) => m.id !== loadingMsgId);

              const assistantMessage = response.choices[0].message.content;
              this.addMessage(assistantMessage, false);

              // Add to chat history
              this.chatHistory.push({ role: 'assistant', content: assistantMessage });
            },
            (error) => {
              console.error('Chat API Error:', error);
              // Remove loading message
              this.messages = this.messages.filter((m) => m.id !== loadingMsgId);
              this.addMessage('Sorry, I encountered an error. Please try again.', false);
            }
          )
          .add(() => {
            this.isWaiting = false;
          });
      } catch (error) {
        console.error('Error sending message:', error);
        this.isWaiting = false;
        // Remove loading message
        this.messages = this.messages.filter((m) => m.id !== loadingMsgId);
        this.addMessage('Sorry, I encountered an error. Please try again.', false);
      }
    }
  }

  private addMessage(text: string, isUser: boolean) {
    this.messages.push({
      id: ++this.messageId,
      text,
      isUser,
    });
  }
}
